---
title: Engineer Offer Breakdown
date: 2025-09-28T12:00:00-07:00
draft: false
---


It's always a bit confusing trying to understand what each companies offer actually means for your total comp each year. I made a simple tool that lets you input the relevant info and gives you a visual breakdown of your total comp over the years. Static site, no backend slurping up data

Best part is the url updates in real time, so you can copy the url (or "Share this offer" button) to show someone else what an offer represents.

- If you're a recruiter, this is an easy tool to help a candidate understand your offer

- If you're asking a friend/mentor/spouse for advice, this is an easy way to give them context

Hope it's helpful!

**[Go to Engineer Offer Breakdown](https://engineer-offer-breakdown.pages.dev/)**
